import { render, staticRenderFns } from "./PreferencesChooseComponent.vue?vue&type=template&id=79ab26c6&"
import script from "./PreferencesChooseComponent.vue?vue&type=script&lang=js&"
export * from "./PreferencesChooseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports